<template>
    <div v-if="jobId && files && files.length > 0">
        <v-btn block color="grey-lighten-2"
               prepend-icon="mdi-briefcase-plus"
               @click="showDialog = true"
               variant="flat">CREATE NIMP TRANSACTION</v-btn>
        <v-dialog v-model="showDialog"
                  fullscreen>
            <v-card>
                <v-toolbar theme="dark">
                    <v-toolbar-title>Create NIMP Transaction</v-toolbar-title>
                    <v-btn icon="mdi-close"
                           @click="showDialog = false"></v-btn>
                </v-toolbar>
                <div class="pa-2">
                    <v-text-field label="Transaction Date"
                                  type="date"
                                  v-model="date"></v-text-field>
                    <v-select label="Transaction Type"
                              v-model="transactionType"
                              :items="['Inward', 'Outward', 'Production']"></v-select>
                    <div v-if="damagedFiles.length > 0" class="my-1 bg-amber-lighten-3 pa-1 rounded-s">
                        <v-select label="Damage Source"
                                  v-model="damageType"
                                  :items="damageTypes"></v-select>
                        <v-icon icon="mdi-glass-fragile" class="mr-1"></v-icon> TRANSACTION MARKED AS DAMAGED
                        <p>Please provide a comment of what caused the damage.</p>
                        <v-textarea label="Comment"
                                    rows="3"
                                    v-model="comment"
                                    outlined
                                    dense></v-textarea>
                    </div>
                    <div v-if="damagedFiles.length == 0">
                        <v-textarea label="Comment"
                                    rows="3"
                                    v-model="comment"
                                    outlined
                                    dense></v-textarea>
                    </div>
                    <v-table v-if="!loading" density="compact" class="text-caption">
                        <tbody>
                            <tr>
                                <th class="w-img"></th>
                                <th class="w-50">File</th>
                                <th class="w-33"></th>
                            </tr>
                            <tr v-for="file in filteredFiles" :key="file.id">
                                <td class="w-img pa-1">
                                    <img v-if="isImage(file)" :src="file.fileLink" alt="image" class="w-100" />
                                </td>
                                <td>
                                    <v-checkbox :label="file.fileName"
                                                :model-value="isSelected(file.id)"
                                                @update:model-value="toggleFile(file)">
                                    </v-checkbox>
                                </td>
                                <td>
                                    <v-checkbox :disabled="!isSelected(file.id)" label="Damaged?"
                                                :model-value="isDamageSelected(file.id)" @update:model-value="toggleDamagedFile(file)"></v-checkbox>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                    <v-row>
                        <v-col cols="6">
                            <v-alert icon="mdi-alert-circle-outline" title="Errors found" variant="outlined" v-if="errors.length > 0" type="warning">
                                <template v-slot:text>
                                    <ul>
                                        <li v-for="error in errors" :key="error">{{ error }}</li>
                                    </ul>
                                </template>
                            </v-alert>
                        </v-col>
                        <v-col cols="6" class="text-right">
                            <v-btn :loading="saving"
                                   flat
                                   :disabled="errors.length > 0"
                                   @click="saveTransaction"
                                   class="mr-2"
                                   color="primary"
                                   prepend-icon="mdi-floppy">SEND</v-btn>
                            <v-btn text="Close"
                                   @click="showDialog = false"></v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
    .w-img {
        width: 20%;
    }
    .nimp-note-input-container {
        border:1px solid black;
        margin-bottom:20px;
    }
</style>
<script>
    import { mapActions, mapState, mapGetters } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false,
            showDialog: false,
            selectedFiles: [],
            damagedFiles: [],
            comment: '',
            damageType: null,
            damageTypes: ["P88", "Nuwall", "McKechnie"],
            date: null,
            transactionType: null
        };
    }
    export default {
        name: "SendFilesNimp",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.reset();
        },
        props: {
            jobId: Number,
            files: Array
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
                this.date = this.$dayjs().format('YYYY-MM-DD');
            },
            isImage(image) {
                var extension = image.saveName.split('.').pop().toLowerCase();
                return ['png', 'jpeg', 'jpg', 'gif', 'tiff', 'tif', 'bmp'].includes(extension);
            },
            isSelected(fileId) {
                return this.selectedFiles.some(f => f.id === fileId);
            },
            toggleFile(file) {
                const index = this.selectedFiles.findIndex(f => f.id === file.id);
                if (index > -1) {
                    this.selectedFiles.splice(index, 1);
                } else {
                    this.selectedFiles.push(file);
                }
            },
            isDamageSelected(fileId) {
                return this.damagedFiles.some(f => f.id === fileId);
            },
            toggleDamagedFile(file) {
                const index = this.damagedFiles.findIndex(f => f.id === file.id);
                if (index > -1) {
                    this.damagedFiles.splice(index, 1);
                } else {
                    this.damagedFiles.push(file);
                }
            },
            saveTransaction() {
                this.$confirm(
                    {
                        message: 'Are you sure you want to send this to NIMP?',
                        disableKeys: false,
                        auth: false,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        },
                        callback: confirm => {
                            if (confirm) {
                                this.saving = true;
                                let formData = new FormData();
                                formData.append('type', this.transactionType);
                                formData.append('jobId', this.jobId);
                                formData.append('note', this.comment);
                                formData.append('date', this.date);
                                formData.append('damageSource', this.damageType || '');
                                let i = 0;
                                this.selectedFiles.forEach(file => {
                                    const isDamaged = this.damagedFiles.some(f => f.id === file.id);
                                    formData.append(`images[${i}].fileUrl`, file.fileLink);
                                    formData.append(`images[${i}].damaged`, isDamaged);
                                    i++;
                                });
                                this.$api.post('/systemfiles/CreateNimpTransaction', formData)
                                    .then(() => {
                                        this.showSuccessSnack('NIMP Transaction created successfully');
                                        this.reset();
                                        this.showDialog = false;
                                    })
                                    .catch((error) => {
                                        this.showErrorSnack('Error creating NIMP Transaction: ' + error.response.data.message || error.message);
                                    })
                                    .finally(() => {
                                        this.saving = false;
                                    });
                            }
                        }
                    }
                )
            }
        },
        computed: {
            filteredFiles() {
                return this.files.filter(file => {
                    return this.isImage(file);
                });
            },
            errors() {
                let errors = [];
                if (!this.transactionType) {
                    errors.push('Need transaction type');
                }
                if (this.selectedFiles.length == 0) {
                    errors.push('Need at least 1 image selected');
                }
                if (this.damagedFiles.length > 0) {
                    if (!this.comment || this.comment.length == 0) {
                        errors.push('Must provide a comment when loading damage');
                    }
                    if (!this.damageType) {
                        errors.push('Must provide a damage source when loading damage');
                    }
                }
                return errors;
            }
        }
    };
</script>